<!--==================================================
    component name  : 空箱查詢 - 彈出視窗 / 空櫃查詢
    author          : Samma
    last update     : 2020-05-08
    use description : 
==================================================-->
<template>
  <div class="tab-inner" id="tab01">
    <carousel
      v-if="is_show_content"
      class="boxall"
      :perPageCustom="[
        [0, 1],
        [414, 1],
        [568, 2],
        [640, 2.1],
        [667, 2.2],
        ,
        [731, 2.2],
        [768, 2.1],
        [823, 2.2],
        [834, 2.2],
        [869, 2.1],
        [1024, 2.3],
        [1080, 2.3],
      ]"
      :paginationEnabled="false"
      :autoplayTimeout="4000"
      :loop="true"
      :autoplay="true"
    >
      <slide
        class="box"
        v-for="(locker, locker_idx) in lockers['lockers_type']"
        v-bind:key="locker_idx"
      >
        <div class="sizebox">
          <div class="sizetext">
            <div class="ibox" v-if="locker.size == 'M'">
              <i class="fas fa-mobile-alt"><i class="fas fa-bolt"></i></i>
            </div>
            <span v-else>{{ locker.size }}</span>
          </div>
          <div class="hour">
            {{ $t('message.qs_fee_dollar', { dollars: locker.unit_fee }) }} /
            {{ $t('message.qs_fee_hours', { hours: locker.unit_hour }) }}
          </div>
          <div class="imgbox">
            <img
              class="img-fluid"
              v-if="locker.spec && locker.spec.length > 0"
              :src="$t('message.qs_img_' + locker.spec)"
              alt="OWLocker智慧型寄物櫃"
            />
          </div>
        </div>
      </slide>
    </carousel>

    <div v-if="is_show_content" class="box2">
      <!--空櫃訊息-->
      <div
        class="sizebox"
        v-for="(locker, locker_idx) in lockers['lockers_type']"
        v-bind:key="locker_idx"
      >
        <div class="sizeLbox">
          <div class="sizeLtext">
            <div class="ibox" v-if="locker.size == 'M'">
              <i class="fas fa-mobile-alt"><i class="fas fa-bolt"></i></i>
            </div>
            <span v-else>{{ locker.size }}</span>
          </div>
        </div>
        <div class="text">
          <span>{{ $t('message.qs_locker_size_' + locker.size) }}</span>
          <div v-if="locker.size == 'M'" class="stext">
            {{ $t('message.qs_mobile_tips') }}
          </div>
          <div class="bar">
            <div
              class="orangebar"
              :style="{ width: (locker.empty / locker.total) * 100 + '%' }"
            ></div>
          </div>
        </div>
        <div class="textempty">{{ locker.empty }}</div>
        <div class="textall">/{{ locker.total }}</div>
        <div class="text2">
          ({{ $t('message.qs_empty_lockers') }}/{{
            $t('message.qs_total_lockers')
          }})
        </div>
      </div>

      <P v-if="lockers['updated_at'] && lockers['updated_at'].length > 0"
        >{{ $t('message.qs_updated_at') }}{{ lockers['updated_at'] }}</P
      >
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'QsTab01',
  components: {
    Carousel,
    Slide,
  },
  data: function () {
    return {
      lockers: {
        lockers_type: [
          /*
              {
                "size"      : "S",
                "total"     : 0,
                "empty"     : 0,
                "unit_fee"  : 40,
                "unit_hour" : 3,
                "spec"      : "58x42x42"
              },
              {
                "size"      : "L",
                "total"     : 0,
                "empty"     : 0,
                "unit_fee"  : 60,
                "unit_hour" : 3,
                "spec"      : "58x84x42"
              },
              {
                "size"      : "M",
                "total"     : 0,
                "empty"     : 0,
                "unit_fee"  : 30,
                "unit_hour" : 3,
                "spec"      : "58x27x27"
              }
              */
        ],
        updated_at: null,
      },
      //是否顯示整個 tab 內容
      is_show_content: true,
    };
  },
  mounted: function () {},
  // updated: function () {
  //   var ref = this;
  //   this.$nextTick(function () {
  //     //副櫃尺寸輪播圖
  //     if( ref.lockers && ref.lockers["lockers_type"] && ref.lockers["lockers_type"].length > 0 &&
  //       $('#locker-size-desc').length !== 0 ) {
  //       var $owl = $('#locker-size-desc');
  //         $owl.owlCarousel({
  //             loop : ( $owl.data('loop') !== true ) ? false : true,
  //             responsive : {
  //                 0 : {
  //                   items : $owl.data('items') !== undefined ? $owl.data('items') : ( ( $owl.data('items-xs') | 0 ) > 0 ) ? ( $owl.data('items-xs') | 0 ) : 1
  //                 },
  //                 568 : {
  //                   items : $owl.data('items') !== undefined ? $owl.data('items') : ( ( $owl.data('items-sm') | 0 ) > 0 ) ? ( $owl.data('items-sm') | 0 ) : 1
  //                 },
  //                 1024 : {
  //                   items : $owl.data('items') !== undefined ? $owl.data('items') : ( $owl.data('items-md') !== undefined ? ( ( $owl.data('items-md') | 0 ) > 0 ) ? ( $owl.data('items-md') | 0 ) : 1 : 1 )
  //                 }
  //             },
  //             autoplay : ( $owl.data('autoplay') !== true ) ? false : true,
  //             autoplaySpeed: 1000,
  //             dots : ( $owl.data('dots') !== true ) ? false : true,
  //             nav : ( $owl.data('nav') !== true ) ? false : true,
  //             margin :( $owl.data('margin') !== null ) ? $owl.data('margin') : 10,
  //             URLhashListener:true,
  //             autoplayHoverPause:false,
  //             startPosition: 'URLHash'
  //         });
  //         //完成初始化後可能會自動隱藏，需移除隱藏元件的類別
  //         $owl.removeClass("owl-hidden");
  //     }
  //   })
  // },
  methods: {
    vInitUIStatus: function () {
      this.vShowContent(false);
      this.vLoadLockersType([]);
      this.vLoadUpdatedAt(null);
    },
    vShowContent: function (is_show) {
      this.is_show_content = is_show;
    },
    vCheckNoContent: function () {
      return (
        !this.lockers['lockers_type'] ||
        this.lockers['lockers_type'].length <= 0
      );
    },
    vLoadLockersType: function (data) {
      //移除副櫃尺寸圖片輪播器 (僅在資料有變動時，將會被 re-render 的情況下)
      // if ( this.lockers["lockers_type"].equals(data) === false ) {
      //     $('#locker-size-desc').trigger('destroy.owl.carousel');
      //     $('#locker-size-desc').find('.owl-stage-outer').children().unwrap();
      //     $('#locker-size-desc').removeClass("owl-center owl-loaded owl-text-select-on");
      // }
      //重置資料
      this.lockers['lockers_type'] = [];
      this.lockers['lockers_type'] = data;
      this.is_show_content = data && data.length > 0 ? true : false;
    },
    vLoadUpdatedAt: function (data) {
      this.lockers['updated_at'] = data;
    },
  },
};
</script>
